<template>
  <div class="bluebtn adjust-custom-padding">
    <b-row>
      <b-col
        v-for="(field, index) in basicArray"
        :key="index"
        :cols="getColumn(field.controlType)"
        class="relativeclass mt-2"
        :class="
          field.controlType == 'boolean' ? 'd-flex align-items-center' : ''
        "
        v-show="!field.hide"
      >
        <div
          v-if="
            field.controlType == 'text' ||
            field.controlType == 'email' ||
            field.controlType == 'number'
          "
          class="topDiv mt-3"
        >
          <InputField
            :type="field.controlType"
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            @select-value="updateFieldValue(field, $event)"
            @handle-input="handleInput(field)"
            @handle-blur="handleBlur(field)"
            :showError="getError(field)"
            :vmodel="getVmodel(field)"
            :disabled="checkdisabled(field.key)"
            :bindingClass="'bindingClass'"
          />
        </div>

        <div
          v-else-if="field.controlType == 'single_select'"
          class="topDiv mt-3"
        >
          <SelectCustom
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            :api="field.apiEndpoint"
            :values="field.values"
            :dropdown="field.dropdown"
            :fieldType="field.fieldType"
            @select-value="updateFieldValue(field, $event)"
            :showError="getError(field)"
            :vmodel="getVmodel(field)"
            :disabled="checkdisabled(field.key)"
            :disableDropdown="checkdisabled(field.key)"
            :selectbindingClass="'selectbindingClass'"
          />
        </div>

        <div
          v-else-if="field.controlType == 'multi_select'"
          class="topDiv mt-3"
        >
          <MultiSelectCustom
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            :api="field.apiEndpoint"
            :values="field.values"
            :dropdown="field.dropdown"
            :fieldType="field.fieldType"
            @select-value="updateFieldValue(field, $event)"
            :showError="getError(field)"
            :vmodel="getVmodel(field)"
            :disabled="checkdisabled(field.key)"
          />
        </div>
        <div
          v-else-if="field.controlType == 'rich_text_box'"
          class="topDiv mt-3"
        >
          <CustomQuillEditor
            :type="field.controlType"
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            :showAILoader="showAILoader"
            @select-value="updateFieldValue(field, $event)"
            @handle-input="handleInput(field)"
            @handle-blur="handleBlur(field)"
            @write-with-hire3x="onWriteWithHire3x"
            :writeButtonDisabled="
              writeButtonDisabled || checkdisabled(field.key)
            "
            :showError="getError(field)"
            :vmodel="getVmodel(field)"
            :field="field"
            :disabled="checkdisabled(field.key)"
            :bindingClass="'bindingClass'"
          />
        </div>
        <div v-else-if="field.controlType == 'boolean'" class="topDiv mt-4">
          <SwitchBox
            :type="field.controlType"
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            @select-value="updateFieldValue(field, $event)"
            :vmodel="getVmodel(field)"
            :disabled="checkdisabled(field.key)"
            :bindingClass="'bindingClass'"
          />
        </div>

        <div v-else-if="field.controlType == 'upload_file'" class="topDiv mt-3">
          <UploadDocument
            :type="field.controlType"
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            @select-value="updateFieldValue(field, $event)"
            @reupload-value="field.isReupload = true"
            :fileFormat="field.fileFormat"
            :showError="getError(field)"
            :maxFileSize="field.maxFileSize"
            :vmodel="getVmodel(field)"
            @update-check="$emit('update-check')"
            :disabled="checkdisabled(field.key)"
          />
        </div>
        <div v-else-if="field.controlType == 'multi_text'" class="topDiv mt-3">
          <FormTags
            :type="field.controlType"
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            @select-value="updateFieldValue(field, $event)"
            :fileFormat="field.fileFormat"
            :showError="getError(field)"
            :maxLength="parseInt(field.limit)"
            :vmodel="getVmodel(field)"
            @handle-input="handleInput(field)"
            @handle-blur="handleBlur(field)"
            @length-error="setLengthError($event, field)"
            :disabled="checkdisabled(field.key)"
            :bindingClass="'bindingClass'"
          />
        </div>
        <div v-else-if="field.controlType == 'date'" class="topDiv mt-3">
          <DateField
            :type="field.controlType"
            :label="field.label"
            :mandatory="field.mandatory"
            :placeholder="field.placeholder"
            :id="field.key"
            @select-value="updateFieldValue(field, $event)"
            :showError="getError(field)"
            :format="field.dateTimeFormat"
            :vmodel="getVmodel(field)"
            :disabled="checkdisabled(field.key)"
          />
        </div>
        <template v-if="touchedFields[field.key] && !lengthError[field.key]">
          <div
            class="newInt-required-validation-font mt-1"
            v-if="field.mandatory && !validateField(field)"
          >
            {{ valText[field.key] }}
          </div>
          <div
            class="newInt-required-validation-font mt-1"
            v-else-if="field.limit > 0 && !validateField(field)"
          >
            {{ valText[field.key] }}
          </div>
        </template>
      </b-col>
    </b-row>
    <div class="d-flex align-items-center mt-4" v-if="advanceArray.length > 0">
      <div
        class="d-flex align-items-center pointer"
        @click="showAdvanced = !showAdvanced"
      >
        <div>
          <img
            v-if="showAdvanced"
            src="../../../assets/customfield/modalTopArrow.svg"
            alt=""
          />
          <img
            v-else
            src="../../../assets/customfield/modalDownArrow.svg"
            alt=""
          />
        </div>
        <div class="cs-bluetxt ml-2 mr-3">Advanced</div>
      </div>
      <div class="modal-horizontal-line"></div>
    </div>
    <template v-if="showAdvanced">
      <b-row>
        <b-col
          v-for="(field, index) in advanceArray"
          :key="index"
          :cols="getColumn(field.controlType)"
          class="relativeclass mt-2"
          :class="
            field.controlType == 'boolean' ? 'd-flex align-items-center' : ''
          "
          v-show="!field.hide"
        >
          <div
            v-if="
              field.controlType == 'text' ||
              field.controlType == 'email' ||
              field.controlType == 'number'
            "
            class="topDiv mt-3"
          >
            <InputField
              :type="field.controlType"
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              @select-value="updateFieldValue(field, $event)"
              @handle-input="handleInput(field)"
              @handle-blur="handleBlur(field)"
              :showError="getError(field)"
              :vmodel="getVmodel(field)"
              :disabled="checkdisabled(field.key)"
              :bindingClass="'bindingClass'"
            />
          </div>

          <div
            v-else-if="field.controlType == 'single_select'"
            class="topDiv mt-3"
          >
            <SelectCustom
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              :api="field.apiEndpoint"
              :values="field.values"
              :dropdown="field.dropdown"
              :fieldType="field.fieldType"
              @select-value="updateFieldValue(field, $event)"
              :showError="getError(field)"
              :vmodel="getVmodel(field)"
              :disableDropdown="checkdisabled(field.key)"
              :disabled="checkdisabled(field.key)"
              :selectbindingClass="'selectbindingClass'"
            />
          </div>

          <div
            v-else-if="field.controlType == 'multi_select'"
            class="topDiv mt-3"
          >
            <MultiSelectCustom
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              :api="field.apiEndpoint"
              :values="field.values"
              :dropdown="field.dropdown"
              :fieldType="field.fieldType"
              @select-value="updateFieldValue(field, $event)"
              :showError="getError(field)"
              :vmodel="getVmodel(field)"
              :disabled="checkdisabled(field.key)"
            />
          </div>
          <div
            v-else-if="field.controlType == 'rich_text_box'"
            class="topDiv mt-3"
          >
            <CustomQuillEditor
              :type="field.controlType"
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              @select-value="updateFieldValue(field, $event)"
              @handle-input="handleInput(field)"
              @handle-blur="handleBlur(field)"
              :showError="getError(field)"
              :disabled="checkdisabled(field.key)"
              :vmodel="getVmodel(field)"
              :bindingClass="'bindingClass'"
            />
          </div>
          <div v-else-if="field.controlType == 'boolean'" class="topDiv mt-4">
            <SwitchBox
              :type="field.controlType"
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              @select-value="updateFieldValue(field, $event)"
              :vmodel="getVmodel(field)"
              :disabled="checkdisabled(field.key)"
              :bindingClass="'bindingClass'"
            />
          </div>

          <div
            v-else-if="field.controlType == 'upload_file'"
            class="topDiv mt-3"
          >
            <UploadDocument
              :type="field.controlType"
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              @select-value="updateFieldValue(field, $event)"
              :fileFormat="field.fileFormat"
              :showError="getError(field)"
              :maxFileSize="field.maxFileSize"
              :vmodel="getVmodel(field)"
              :disabled="checkdisabled(field.key)"
              @update-check="$emit('update-check')"
            />
          </div>
          <div
            v-else-if="field.controlType == 'multi_text'"
            class="topDiv mt-3"
          >
            <FormTags
              :type="field.controlType"
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              @select-value="updateFieldValue(field, $event)"
              :fileFormat="field.fileFormat"
              :showError="getError(field)"
              :maxLength="parseInt(field.limit)"
              :vmodel="getVmodel(field)"
              :disabled="checkdisabled(field.key)"
              @length-error="setLengthError($event, field)"
              @handle-input="handleInput(field)"
              @handle-blur="handleBlur(field)"
              :bindingClass="'bindingClass'"
            />
          </div>
          <div v-else-if="field.controlType == 'date'" class="topDiv mt-3">
            <DateField
              :type="field.controlType"
              :label="field.label"
              :mandatory="field.mandatory"
              :placeholder="field.placeholder"
              :id="field.key"
              @select-value="updateFieldValue(field, $event)"
              :showError="getError(field)"
              :format="field.dateTimeFormat"
              :vmodel="getVmodel(field)"
              :disabled="checkdisabled(field.key)"
            />
          </div>
          <template v-if="touchedFields[field.key] && !lengthError[field.key]">
            <div
              class="newInt-required-validation-font mt-1"
              v-if="field.mandatory && !validateField(field)"
            >
              {{ valText[field.key] }}
            </div>
            <div
              class="newInt-required-validation-font mt-1"
              v-else-if="field.limit > 0 && !validateField(field)"
            >
              {{ valText[field.key] }}
            </div>
          </template>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
import {
  columnWidth,
  showError,
  validateField,
} from "../../../utils/customFields";
import InputField from "../../../components/InputComponents/Input.vue";
import SwitchBox from "../../../components/InputComponents/Switch.vue";
import CustomQuillEditor from "../../../components/InputComponents/CustomQuillEditor.vue";
import SelectCustom from "../../../components/InputComponents/SelectCustom.vue";
import MultiSelectCustom from "../../../components/InputComponents/MultiSelectCustom.vue";
import UploadDocument from "../../../components/InputComponents/UploadDocument.vue";
import FormTags from "../../../components/InputComponents/FormTags";
import DateField from "../../../components/InputComponents/DateField";
import EventBus from "../../../utils/eventBus";
export default {
  name: "BasicDetails",
  props: {
    writeButtonDisabled: Boolean,
    customFieldsArray: Array,
    touchedFields: Object,
    newObject: Object,
    validations: Object,
    basicArray: Array,
    advanceArray: Array,
    savedOpeningsCount: Number,
    showAILoader: Boolean,
    isOnlyLeadRecruiter: Boolean,
  },
  components: {
    InputField,
    SwitchBox,
    CustomQuillEditor,
    SelectCustom,
    MultiSelectCustom,
    UploadDocument,
    FormTags,
    DateField,
  },
  data() {
    return {
      valText: {},
      lengthError: {},
      showAdvanced: true,
    };
  },
  mounted() {
    EventBus.$on("validate-form", this.validateForm);
  },
  methods: {
    setLengthError(value, field) {
      this.lengthError[field.key] = value;
      this.$forceUpdate();
    },
    checkdisabled(key) {
      if (this.isOnlyLeadRecruiter) {
        const notRestricted = [
          "documents",
          "requiredDocumets",
          "ijp",
          "openToPublic",
        ];
        if (notRestricted.includes(key)) {
          return false;
        }
        return true;
      }
      return false;
    },
    onWriteWithHire3x(field) {
      this.$emit("write-with-hire3x", field);
    },
    getColumn(field) {
      return columnWidth(field);
    },
    getError(field) {
      const isError = showError(field, this.touchedFields[field.key], this);
      this.$emit("error-check", isError, field.key);
      return isError;
    },
    handleInput(field) {
      this.touchedFields[field.key] = true;
      this.$forceUpdate();
    },
    handleBlur(field) {
      if (this.touchedFields[field.key] && !this.validations[field.key]) {
        validateField(field, this);
        this.$forceUpdate();
      }
    },
    updateFieldValue(field, value) {
      this.$emit("set-value", field, value);
      if (field.key === "title" || field.key === "openingsCount") {
        this.$emit("job-title-error", validateField(field, this), field.key);
      }
      validateField(field, this);
    },
    validateField(field) {
      return validateField(field, this);
    },
    getVmodel(field) {
      return field.fieldType == "default"
        ? this.newObject[field.key]
        : this.newObject.customFields[field.key];
    },
    validateForm() {
      let invalidForm = false;
      for (let i = 0; i < this.customFieldsArray.length; i++) {
        const field = this.customFieldsArray[i];
        this.$emit("set-touched-fields", field.key);
        this.$forceUpdate();
        if (!validateField(field, this)) {
          invalidForm = true;
        }
      }
      return invalidForm;
    },
  },
};
</script>
